<template>
  <div v-if="(emailExists && isGuest) || !emailExists">
    <template v-if="emailExists && isGuest">
      <div class="d-flex align-items-center mb-1">
        <v-icon icon="warning" size="1.2rem" class="mr-1 danger" />
        <span class="text-muted text-small opacity-50">
          {{ $t("components.checkout.emailFieldCta.emailAlreadyExists") }}
        </span>
      </div>
      <v-button block small @click="() => openAuthModal()">
        {{ $t("components.checkout.emailFieldCta.login") }}
      </v-button>
    </template>
    <template v-else-if="!emailExists">
      <div class="text-small d-flex align-items-center px-1 pt-1 mb-n1">
        {{ $t("components.checkout.emailFieldCta.alreadyAMember") }}
        <v-button small ghost class="p-0 ml-1" @click="() => openAuthModal()">
          {{ $t("components.checkout.emailFieldCta.login") }}
        </v-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import { STAGES as AUTH_STAGES } from "@/components/AuthModal"

export default {
  props: {
    emailExists: { type: Boolean, required: true }
  },

  computed: {
    ...mapGetters("auth", ["isGuest"])
  },

  methods: {
    openAuthModal() {
      this.$router.push(AUTH_STAGES.INITIAL, { append: true })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.danger {
  color: $color-ui--red;
}
</style>
